import { useEffect, useState } from 'react'
const IS_DEV = process.env.NODE_ENV === 'development'

const OrganizationLogo = ({ slug, styles = null, onCheck = null }) => {
  const [organizationLogo, setOrganizationLogo] = useState(null)

  const localLogoPath = `${CONFIG.assetsBaseURL}/images/organization-license-logos`
  const s3LogoPath = `${CONFIG.cdnURL}/usercontent/orglogos`

  const orgLogosPath = IS_DEV ? localLogoPath : s3LogoPath

  const logosInPublicFolder = [
    'astra-zeneca-2208-1',
    'purdue-university',
    'university-of-zurich',
    'zambon',
    'the-hang-seng-university-of'
  ]

  const checkImageExists = () => {
    if (!slug) return setOrganizationLogo(null)

    const imageUrl = `${orgLogosPath}/${slug}${IS_DEV ? '.png' : ''}`

    if (organizationLogo === imageUrl) return // Skip if already loaded

    // eslint-disable-next-line
    const image = new Image()
    image.src = imageUrl

    image.onerror = () => {
      // validation for logos that aren't stored in S3, but exists in public folder
      if (slug && logosInPublicFolder.includes(slug)) {
        const srcInPublicFoler = `${localLogoPath}/${slug}.png`
        return setOrganizationLogo(srcInPublicFoler)
      }

      setOrganizationLogo(null)

      if (onCheck) {
        onCheck(null)
      }
    }

    image.onload = () => {
      setOrganizationLogo(imageUrl)
      if (onCheck) {
        onCheck(imageUrl)
      }
    }
  }

  useEffect(() => {
    checkImageExists()
  }, [slug])

  return (
    <>{organizationLogo && <img src={organizationLogo} alt={`Organization logo of ${slug}`} className={styles} />}</>
  )
}

export default OrganizationLogo
